'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _blocks = require('../blocks');

var _is = require('../is');

var _astLocUtils = require('ast-loc-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// c/p https://github.com/babel/babel/blob/master/packages/babel-types/src/converters.js

// Convert a series of statements to an expression.
// Largely c/p from babel-types and babel-traverse.
// Modified to add source mapping information to produced nodes.
function gatherSequenceExpressions(nodes) {
  var exprs = [];
  var ensureLastNull = true;

  for (var _i2 = 0, _len2 = nodes.length; _i2 < _len2; _i2++) {
    var _node = nodes[_i2];
    ensureLastNull = false;

    if ((0, _is.isa)(_node, "Expression")) {
      exprs.push(_node);
    } else if ((0, _is.isa)(_node, "ExpressionStatement")) {
      exprs.push(_node.expression);
    } else if ((0, _is.isa)(_node, "IfStatement")) {
      var _consequent = _node.consequent,
          _alternate = _node.alternate,
          _test = _node.test;

      var cq = _consequent; // XXX: https://github.com/lightscript/lightscript/issues/39
      var alt = _alternate; // XXX: https://github.com/lightscript/lightscript/issues/39
      if (!cq) return;
      var nextCq = gatherSequenceExpressions([cq]);
      var nextAlt = alt ? gatherSequenceExpressions([alt]) : (0, _astLocUtils.placeAtNode)(_types2.default.nullLiteral(), cq);
      if (!nextCq || !nextAlt) return;

      var loc = (0, _astLocUtils.getSurroundingLoc)([_test, nextCq, nextAlt]);
      exprs.push((0, _astLocUtils.placeAtLoc)(_types2.default.conditionalExpression(_test, nextCq, nextAlt), loc));
    } else if ((0, _is.isa)(_node, "BlockStatement")) {
      var body = gatherSequenceExpressions(_node.body);
      if (!body) return;
      exprs.push(body);
    } else if ((0, _is.isa)(_node, "EmptyStatement")) {
      ensureLastNull = true;
    } else {
      return;
    }
  }if (ensureLastNull) {
    exprs.push((0, _astLocUtils.placeAtNode)(_types2.default.nullLiteral(), exprs[exprs.length - 1]));
  }if (exprs.length === 1) return exprs[0];else return _types2.default.sequenceExpression(exprs);
}function toSequenceExpression(nodes) {
  if (!nodes || !nodes.length) return;
  return gatherSequenceExpressions(nodes);
} // c/p https://github.com/babel/babel/blob/1e55653ac173c3a59f403a7b5269cf6d143d32d9/packages/babel-traverse/src/path/replacement.js

exports.default = function statementsToExpression(path, nodes) {
  path.resync();

  var seqExpr = toSequenceExpression(nodes);

  if (_types2.default.isSequenceExpression(seqExpr)) {
    var exprs = seqExpr.expressions;

    if (exprs.length >= 2 && path.parentPath.isExpressionStatement()) {
      path._maybePopFromStatements(exprs);
    } // could be just one element due to the previous maybe popping
    if (exprs.length === 1) return exprs[0];else return seqExpr;
  } else if (seqExpr) {
    return seqExpr;
  } else {
    return (0, _blocks.iife)(nodes);
  }
};

module.exports = exports['default'];